import { render } from "./course-home.vue?vue&type=template&id=05208f4a&ts=true"
import script from "./course-home.vue?vue&type=script&lang=ts"
export * from "./course-home.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__